import React from 'react';
import classnames from 'classnames';

import { RichText, InnerBlocks } from '../assets/components';

export function IntroSection({ data, ...rest }) {
  const { attributes, innerBlocks } = data;

  const { className, tagName: Tag, blockClass, tagline, content, prefix, buttonText } = attributes;

  const blockClasses = classnames(blockClass, className, {});

  const innerWrapClasses = classnames(`${prefix}__wrap`, {});

  const taglineClasses = classnames(`${prefix}__tagline`, {});

  const contentClasses = classnames(`${prefix}__paragraph`, {});

  const innerBlocksClasses = classnames(`${prefix}__inner-blocks`, {});
  const buttonTextClasses = classnames(`${prefix}__buttonText`, {});

  return (
    <>
      <Tag className={blockClasses}>
        <div className={innerWrapClasses}>
          <RichText className={taglineClasses} tagName="h2" value={tagline} />
          <RichText className={contentClasses} tagName="p" value={content} />
          <InnerBlocks className={innerBlocksClasses} blocks={innerBlocks} />
          {(buttonText) && (
            <div className={buttonTextClasses}>
              <RichText tagName="p" value={buttonText} />
            </div>
          )}
        </div>
      </Tag>
    </>
  );
}
